import { useRef, useState } from 'react';
import { useClickOutside } from 'common/hooks';
import { FilterLines } from 'pages/LienKetVung/icons';
import { ArrowUp } from 'components/icons';
import IconCheck from 'containers/menu/panoMenu/iconCheck';

export const FilterSelect = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleBtnRef = useRef(null);

  const dropdownRef = useClickOutside(() => setIsOpen(false), [toggleBtnRef]);

  return (
    <div className="filter-select">
      <button
        ref={toggleBtnRef}
        className={`filter-select-trigger ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <FilterLines size={18} color="#fff" />
          <span>Filters</span>
        </div>
        <ArrowUp />
      </button>
      {isOpen && (
        <div ref={dropdownRef} className="filter-select-dropdown">
          {props.filterItems.map((filter) => {
            const Icon = filter.icon;
            const isActive = props.currentFilters.includes(filter.id);
            return (
              <button
                className={`filter-button ${isActive ? 'active' : ''}`}
                onClick={props.onChangeFilter}
                data-id={filter.id}
              >
                <div>
                  <Icon color={isActive ? '#F0B619' : '#fff'} />
                  <span>{filter.label}</span>
                </div>
                <IconCheck size={12} color={isActive ? '#F0B619' : '#fff'} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
